import React from 'react';

export function DeliveryFilterIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M17.2581 10.4184C17.2581 9.89502 16.8391 9.47059 16.3225 9.47059H3.67755C3.16089 9.47059 2.74194 9.89502 2.74194 10.4184V14.7325C2.7422 14.7502 2.75627 14.7644 2.77369 14.7647H17.2263C17.2437 14.7644 17.2578 14.7502 17.2581 14.7325V10.4184ZM19 14.7325C18.9997 15.7248 18.2058 16.5291 17.2263 16.5294H2.77369C1.79423 16.5291 1.00027 15.7248 1 14.7325V10.4184C1 8.9204 2.19885 7.70588 3.67755 7.70588H16.3225C17.8012 7.70588 19 8.9204 19 10.4184V14.7325Z'
        fill='currentColor'
      />
      <path
        d='M17.2581 10.4184C17.2581 9.89502 16.8391 9.47059 16.3225 9.47059H3.67755C3.16089 9.47059 2.74194 9.89502 2.74194 10.4184V14.7325C2.7422 14.7502 2.75627 14.7644 2.77369 14.7647H17.2263C17.2437 14.7644 17.2578 14.7502 17.2581 14.7325V10.4184ZM19 14.7325C18.9997 15.7248 18.2058 16.5291 17.2263 16.5294H2.77369C1.79423 16.5291 1.00027 15.7248 1 14.7325V10.4184C1 8.9204 2.19885 7.70588 3.67755 7.70588H16.3225C17.8012 7.70588 19 8.9204 19 10.4184V14.7325Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M13.1425 3C14.3452 3 15.4006 3.8125 15.7225 4.98644L16.6457 8.35156L14.9672 8.82491L14.0441 5.45864C13.9316 5.04856 13.5627 4.76471 13.1425 4.76471H6.85748C6.43733 4.76471 6.06843 5.04856 5.9559 5.45864L5.03276 8.82491L3.35433 8.35156L4.27747 4.98644C4.5994 3.8125 5.6548 3 6.85748 3H13.1425Z'
        fill='currentColor'
      />
      <path
        d='M13.1425 3C14.3452 3 15.4006 3.8125 15.7225 4.98644L16.6457 8.35156L14.9672 8.82491L14.0441 5.45864C13.9316 5.04856 13.5627 4.76471 13.1425 4.76471H6.85748C6.43733 4.76471 6.06843 5.04856 5.9559 5.45864L5.03276 8.82491L3.35433 8.35156L4.27747 4.98644C4.5994 3.8125 5.6548 3 6.85748 3H13.1425Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M5.64516 12.1176C5.64516 12.605 5.25522 13 4.77419 13C4.29317 13 3.90323 12.605 3.90323 12.1176C3.90323 11.6303 4.29317 11.2353 4.77419 11.2353C5.25522 11.2353 5.64516 11.6303 5.64516 12.1176Z'
        fill='currentColor'
      />
      <path
        d='M5.64516 12.1176C5.64516 12.605 5.25522 13 4.77419 13C4.29317 13 3.90323 12.605 3.90323 12.1176C3.90323 11.6303 4.29317 11.2353 4.77419 11.2353C5.25522 11.2353 5.64516 11.6303 5.64516 12.1176Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M16.0968 12.1176C16.0968 12.605 15.7068 13 15.2258 13C14.7448 13 14.3548 12.605 14.3548 12.1176C14.3548 11.6303 14.7448 11.2353 15.2258 11.2353C15.7068 11.2353 16.0968 11.6303 16.0968 12.1176Z'
        fill='currentColor'
      />
      <path
        d='M16.0968 12.1176C16.0968 12.605 15.7068 13 15.2258 13C14.7448 13 14.3548 12.605 14.3548 12.1176C14.3548 11.6303 14.7448 11.2353 15.2258 11.2353C15.7068 11.2353 16.0968 11.6303 16.0968 12.1176Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M12.3226 11.2353C12.8036 11.2353 13.1935 11.6303 13.1935 12.1176C13.1935 12.605 12.8036 13 12.3226 13H7.67742C7.1964 13 6.80645 12.605 6.80645 12.1176C6.80645 11.6303 7.1964 11.2353 7.67742 11.2353H12.3226Z'
        fill='currentColor'
      />
      <path
        d='M12.3226 11.2353C12.8036 11.2353 13.1935 11.6303 13.1935 12.1176C13.1935 12.605 12.8036 13 12.3226 13H7.67742C7.1964 13 6.80645 12.605 6.80645 12.1176C6.80645 11.6303 7.1964 11.2353 7.67742 11.2353H12.3226Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M2.61152 15.6471H6.09539V16.8235C6.09539 17.4733 5.57546 18 4.9341 18H3.77281C3.13144 18 2.61152 17.4733 2.61152 16.8235V15.6471Z'
        fill='currentColor'
      />
      <path
        d='M2.61152 15.6471H6.09539V16.8235C6.09539 17.4733 5.57546 18 4.9341 18H3.77281C3.13144 18 2.61152 17.4733 2.61152 16.8235V15.6471Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
      <path
        d='M13.2571 15.6471H16.7409V16.8235C16.7409 17.4733 16.221 18 15.5796 18H14.4183C13.777 18 13.2571 17.4733 13.2571 16.8235V15.6471Z'
        fill='currentColor'
      />
      <path
        d='M13.2571 15.6471H16.7409V16.8235C16.7409 17.4733 16.221 18 15.5796 18H14.4183C13.777 18 13.2571 17.4733 13.2571 16.8235V15.6471Z'
        fill='currentColor'
        fillOpacity='0.2'
      />
    </svg>
  );
}
